import '../LibraryBoxBattle.scss'
import NP from "../../../1. Core/NP";
import Control from "../../../1. Core/Control";
import ListBox from "../../../1. Core/Controls/ListBox/ListBox";
import ListItem from "../../../1. Core/Controls/ListBox/ListItem";
import {ServerAPI} from "../../../1. Core/ServerAPI";
import {getWeightStringById} from "../../Util";
import {IAthlete} from "../../types";

export default class AthletesInfoPanel extends Control {

	private _listBox: ListBox;

	_initFields(settings: object)
	{
		super._initFields(settings);
	}

	constructor(settings?: object)
	{
		super(settings);
		this._render();
	}

	_render()
	{
		this._initComponent('<div class="athlete-info-panel"></div>');

		this._listBox = new ListBox({
			ParentNode: this._root,
			Selectable: false,
			TwoLines: true,
			Class: 'app-list--accent'
		});

		this._renderItems([this._root], this._ParentNode || document.documentElement);
	}

	refresh(id: number)
	{
		this._listBox.clear();

		let isRu = NP.getCurrentUser().getRegionalSettings().Lang == 'ru';
		let excludeList = ['Id', 'StateIds', 'CountryId', 'Rating', 'isMMA'];
		ServerAPI.get(`/athlete/${id}`).then((athlete: IAthlete) =>
		{
			for (let key in athlete)
			{
				if (key == 'FirstNameRU' || key == 'LastNameRU')
					if (!isRu)
						continue;

				if (excludeList.indexOf(key) > -1)
					continue;

				let value = (athlete as any)[key];

				if (key == 'WeightCategory')
					value = getWeightStringById(value);

				if (key == 'Sex')
					value = value == 1 ? NP.RM.getString('MaleSex') : NP.RM.getString('FemaleSex');

				if (key == 'Stance')
					value = NP.RM.getString(value);


				if (value)
					this._listBox.addItem(new ListItem({
						Class: 'app-list-item--no-hover selectable cursor--default',
						Selectable: false,
						Content: NP.RM.getString(key) || key,
						SecondLine: value
					}));

			}

			// this._listBox.addItem(new ListItem({
			// 	Class: 'app-list-item--no-hover',
			// 	Content: NP.RM.getString('AIBACard'),
			// 	Selectable: false,
			// 	EvClick: () => window.open(NP.Config.Origin + 'img/AIBA.pdf')
			// }));
		});
	}

};